import React from "react";
import { Container } from "@chakra-ui/react";
import ListTag from "views/admin/Tag/components/ListTag";

const Tag = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListTag />
    </Container>
  );
};

export default Tag;
